<template>
    <div class="content-container">

        <div class="header">
            <div class="title">Forum Settings</div>
        </div>        

        <div class="content form-content">    

            <div class="edit-row">
                <span><a target="_blank" href="https://momentjs.com/docs/#/displaying/format/">Date/Time Format Reference</a></span>
            </div>
            <div class="edit-row">
                <div class="caption">Date Format</div>
                <button @click="selectDateFormat" style="float: right">...</button>
                <input v-model="dateFormat" />
                <button type="button" style="float: right">...</button>
            </div>
            <div class="edit-row">
                <div class="caption">Time Format</div>
                <button @click="selectDateFormat" style="float: right">...</button>
                <input v-model="timeFormat" />
            </div>

            <hr />

            <!--<div class="edit-row">
                <div class="caption">Posting Format</div>
                <select v-model="postFormat">
                    <option v-for="option in postFormatOptions" :key="option.value" :value="option.value">{{ option.display }}</option>
                </select>
            </div>-->

            <div class="edit-row">
                <div class="caption">Post Display Order</div>
                <select v-model="postOrder">
                    <option v-for="option in postOrderOptions" :key="option.value" :value="option.value">{{ option.display }}</option>
                </select>
            </div>
            <div class="edit-row">
                <div class="caption">Posts per Page</div>
                <input v-model="postsPerPage" />
            </div>
            <div class="edit-row">
                <div class="caption">Topics per Page</div>
                <input v-model="topicsPerPage" />
            </div>

            <hr />

            <div class="edit-row">Topic Auto-Subscriptions</div>

            <div class="edit-row">                
                <div class="caption">On Reply - Site Notifications</div>
                <input type="checkbox" v-model="autoSubscribeTopicReplySiteNotification" />
            </div>
            <div class="edit-row">                
                <div class="caption">On Reply - Email Notifications</div>
                <input type="checkbox" v-model="autoSubscribeTopicReplyEmail" />
            </div>

            <div class="edit-row">                
                <div class="caption">On Create - Site Notifications</div>
                <input type="checkbox" v-model="autoSubscribeTopicCreateSiteNotification" />
            </div>
            <div class="edit-row">                
                <div class="caption">On Create - Email Notifications</div>
                <input type="checkbox" v-model="autoSubscribeTopicCreateEmail" />
            </div>

            <hr />

            <div class="edit-row">                
                <div class="caption">View Avatars</div>
                <input type="checkbox" v-model="viewAvatars" />
            </div>
            <div class="edit-row">                
                <div class="caption">View Signature</div>
                <input type="checkbox" v-model="viewSignatures" />
            </div>
            
            <div class="edit-row">
                <div class="caption">Use Emoticons</div>
                <input type="checkbox" v-model="useEmoticons" />
            </div>

            <!--<div class="edit-row">
                <div class="caption">Use New Editor</div>
                <input type="checkbox" v-model="useCkEditor" />
            </div>-->

            <hr />

            <div class="edit-row">
                <div class="caption">Theme</div>
                <select v-model="selectedTheme">
                    <option value="white">White (default)</option>
                    <option value="blue">Blue (beta)</option>
                    <option value="dark">Dark (beta)</option>
                </select>
            </div>
            <hr />
            <div><em>Note: The following settings override theme styles and are applicable to post content only.  Be sure to adjustment them as needed after changing to a different theme.</em></div>
            <hr />
            <div class="edit-row">            
                <div class="caption">Font size</div>
                <select v-model="fontSize">
                    <option value="default">Default</option>
                    <option value="18">X-Large</option>
                    <option value="16">Large</option>
                    <option value="14">Medium</option>
                    <option value="12">Small</option>
                    <option value="10">X-Small</option>
                </select>                
            </div>
            <div class="edit-row">
                <div class="caption">Font color</div>
                <input v-model="fontColor" />
            </div>
            <div class="edit-row">
                <div class="caption">Font weight</div>
                <select v-model="fontWeight">
                    <option value="default">Default</option>
                    <option value="600">Bold</option>
                    <option value="500">Medium Bold</option>
                    <option value="400">Normal</option>
                    <option value="300">Medium Light</option>
                    <option value="200">Light</option>
                </select>
            </div>
            <div class="edit-row">            
                <div class="caption">Code Font size</div>
                <select v-model="codeFontSize">
                    <option value="default">Default</option>
                    <option value="18">X-Large</option>
                    <option value="16">Large</option>
                    <option value="14">Medium</option>
                    <option value="12">Small</option>
                    <option value="10">X-Small</option>
                </select>                
            </div>
        </div>

        <div class="footer">
            <div class="footer-right">
                <button v-on:click="cancel" >Cancel</button>
                <button v-on:click="submit">Submit</button>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '../../api/api'
    import user from '../../store/models/user'
    import dialogs from '../../modules/dialogs'
    import DateFormatDialog from './DateFormatDialog.vue';

    export default {

        props: ['settings', 'memberId'],

        data() {
            return {

                dateFormat: null,
                timeFormat: null,
                postFormat: null,
                postOrder: null,
                postsPerPage: null,
                topicsPerPage: null,
                useMessaging: null,
                useEmoticons: null,
                viewSignatures: null,
                viewAvatars: null,
                selectedTheme: 'medium',
                fontSize: null,
                fontColor: null,
                fontWeight: null,
                autoSubscribeTopicReplySiteNotification: null,
                autoSubscribeTopicReplyEmail: null,
                autoSubscribeTopicCreateSiteNotification: null,
                autoSubscribeTopicCreateEmail: null,
                useCkEditor: null,
                codeFontSize: null,

                postFormatOptions: [
                    { value: 'wysiwyg', display: 'WYSIWYG' },
                    { value: 'bbcode', display: 'BB Code' },
                    { value: 'markdown', display: 'Markdown' }
                ],
                postOrderOptions: [
                    { value: 'asc', display: 'Ascending' },
                    { value: 'desc', display: 'Descending' },
                ],

                originalSettings: {
                    dateFormat: null,
                    timeFormat: null,
                    postFormat: null,
                    postOrder: null,
                    postsPerPage: null,
                    topicsPerPage: null,
                    useMessaging: null,
                    useEmoticons: null,
                    viewSignatures: null,
                    viewAvatars: null,
                    selectedTheme: null,
                    fontSize: null,
                    fontColor: null,
                    fontWeight: null,
                    autoSubscribeTopicReplySiteNotification: null,
                    autoSubscribeTopicReplyEmail: null,
                    autoSubscribeTopicCreateSiteNotification: null,
                    autoSubscribeTopicCreateEmail: null,
                    codeFontSize: null,
                    useCkEditor: null,
                }
            }
        },

        methods: {

            submit: function() {

                let data = {};

                if(this.memberId) {
                  data.memberID = this.memberId;
                }
                else{
                  data.memberID = parseInt(this.$store.getters.user.id);
                }

                data.settings = [
                  { id: user.settingKeys.DATE_FORMAT, value: this.dateFormat },
                  { id: user.settingKeys.TIME_FORMAT, value: this.timeFormat },
                  { id: user.settingKeys.POST_FORMAT, value: this.postFormat },
                  { id: user.settingKeys.POST_ORDER, value: this.postOrder },
                  { id: user.settingKeys.POSTS_PER_PAGE, value: this.postsPerPage.toString() },
                  { id: user.settingKeys.TOPICS_PER_PAGE, value: this.topicsPerPage.toString() },
                  { id: user.settingKeys.USE_MESSAGING, value: this.useMessaging.toString() },
                  { id: user.settingKeys.USE_EMOTICONS, value: this.useEmoticons.toString() },
                  { id: user.settingKeys.VIEW_SIGNATURES, value: this.viewSignatures.toString() },
                  { id: user.settingKeys.VIEW_AVATARS, value: this.viewAvatars.toString() },
                  { id: user.settingKeys.THEME, value: this.selectedTheme.toString() },
                  { id: user.settingKeys.FONT_SIZE, value: this.fontSize.toString() },
                  { id: user.settingKeys.FONT_COLOR, value: this.fontColor.toString() },
                  { id: user.settingKeys.FONT_WEIGHT, value: this.fontWeight.toString() },
                  { id: user.settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_SITE_NOTIFICATION, value: this.autoSubscribeTopicReplySiteNotification.toString() },
                  { id: user.settingKeys.AUTO_SUBSCRIBE_TOPIC_REPLY_EMAIL, value: this.autoSubscribeTopicReplyEmail.toString() },
                  { id: user.settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_SITE_NOTIFICATION, value: this.autoSubscribeTopicCreateSiteNotification.toString() },
                  { id: user.settingKeys.AUTO_SUBSCRIBE_TOPIC_CREATE_EMAIL, value: this.autoSubscribeTopicCreateEmail.toString() },
                  { id: user.settingKeys.CODE_FONT_SIZE, value: this.codeFontSize.toString() },
                  { id: user.settingKeys.USE_CKEDITOR, value: this.useCkEditor.toString() },
                ];
                
                api.post('/members/' + data.memberID + '/settings', data)
                    .then(() => {
                        dialogs.alertAsync('Settings saved');                      
                    }).catch(() => {
                        dialogs.alertAsync('Sorry, Settings failed to save...');
                    });                    
            },

            async cancel() {

                if (dialogs.confirmCancelAsync('Are you sure you want to cancel your changes?')) {
                    this.dateFormat = this.originalSettings.dateFormat;
                    this.timeFormat = this.originalSettings.timeFormat;
                    this.postFormat = this.originalSettings.postFormat;
                    this.postOrder = this.originalSettings.postOrder;
                    this.postsPerPage = this.originalSettings.postsPerPage;
                    this.topicsPerPage = this.originalSettings.topicsPerPage;
                    this.useMessaging = this.originalSettings.useMessaging;
                    this.useEmoticons = this.originalSettings.useEmoticons;
                    this.viewSignatures = this.originalSettings.viewSignatures;
                    this.viewAvatars = this.originalSettings.viewAvatars;
                    this.selectedTheme = this.originalSettings.selectedTheme;
                    this.fontSize = this.originalSettings.fontSize;
                    this.fontColor = this.originalSettings.fontColor;
                    this.fontWeight = this.originalSettings.fontWeight;
                    this.autoSubscribeTopicReplySiteNotification = this.originalSettings.autoSubscribeTopicReplySiteNotification;
                    this.autoSubscribeTopicReplyEmail = this.originalSettings.autoSubscribeTopicReplyEmail;
                    this.autoSubscribeTopicCreateSiteNotification = this.originalSettings.autoSubscribeTopicCreateSiteNotification;
                    this.autoSubscribeTopicCreateEmail = this.originalSettings.autoSubscribeTopicCreateEmail;
                    this.codeFontSize = this.originalSettings.codeFontSize;
                    this.useCkEditor = this.originalSettings.useCkEditor;
                }
            },

            async selectDateFormat() {
                const model = { 
                    dateFormat: this.dateFormat,
                    timeFormat: this.timeFormat, 
                };

                if(await dialogs.showDialogAsync(DateFormatDialog, model)) {
                    this.dateFormat = model.dateFormat;
                    this.timeFormat = model.timeFormat;
                }
            },
        },

        mounted() {

            this.dateFormat = this.settings.dateFormat;
            this.timeFormat = this.settings.timeFormat;
            this.postFormat = this.settings.postFormat;
            this.postOrder = this.settings.postOrder;
            this.postsPerPage = this.settings.postsPerPage;
            this.topicsPerPage = this.settings.topicsPerPage;
            this.useMessaging = this.settings.useMessaging;
            this.useEmoticons = this.settings.useEmoticons;
            this.viewSignatures = this.settings.viewSignatures;
            this.viewAvatars = this.settings.viewAvatars;
            this.selectedTheme = this.settings.selectedTheme;
            this.fontSize = this.settings.fontSize;
            this.fontColor = this.settings.fontColor;
            this.fontWeight = this.settings.fontWeight;
            this.autoSubscribeTopicReplySiteNotification = this.settings.autoSubscribeTopicReplySiteNotification;
            this.autoSubscribeTopicReplyEmail = this.settings.autoSubscribeTopicReplyEmail;
            this.autoSubscribeTopicCreateSiteNotification = this.settings.autoSubscribeTopicCreateSiteNotification;
            this.autoSubscribeTopicCreateEmail = this.settings.autoSubscribeTopicCreateEmail;
            this.codeFontSize = this.settings.codeFontSize;
            this.useCkEditor = this.settings.useCkEditor;
            
            this.originalSettings.dateFormat = this.settings.dateFormat;
            this.originalSettings.timeFormat = this.settings.timeFormat;
            this.originalSettings.postFormat = this.settings.postFormat;
            this.originalSettings.postOrder = this.settings.postOrder;
            this.originalSettings.postsPerPage = this.settings.postsPerPage;
            this.originalSettings.topicsPerPage = this.settings.topicsPerPage;
            this.originalSettings.useMessaging = this.settings.useMessaging;
            this.originalSettings.useEmoticons = this.settings.useEmoticons;
            this.originalSettings.viewSignatures = this.settings.viewSignatures;
            this.originalSettings.viewAvatars = this.settings.viewAvatars;
            this.originalSettings.selectedTheme = this.settings.selectedTheme;
            this.originalSettings.fontSize = this.settings.fontSize;
            this.originalSettings.fontColor = this.settings.fontColor;
            this.originalSettings.fontWeight = this.settings.fontWeight;
            this.originalSettings.autoSubscribeTopicReplySiteNotification = this.settings.autoSubscribeTopicReplySiteNotification;
            this.originalSettings.autoSubscribeTopicReplyEmail = this.settings.autoSubscribeTopicReplyEmail;
            this.originalSettings.autoSubscribeTopicCreateSiteNotification = this.settings.autoSubscribeTopicCreateSiteNotification;
            this.originalSettings.autoSubscribeTopicCreateEmail = this.settings.autoSubscribeTopicCreateEmail;
            this.originalSettings.codeFontSize = this.settings.codeFontSize;
            this.originalSettings.useCkEditor = this.settings.useCkEditor;
        }
    }

</script>